import * as types from './type';

const initialState = {
    spotifyPlaylistObject: ''
};

export default function spotifyReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_SPOTIFY_PLAYLISTS: {
            // console.log('red', action.payload.data)
            const responseData = action.payload && action.payload.data 
                ? action.payload.data
                : null;
            if (responseData) {
                return {
                    ...state,
                    spotifyPlaylistObject: {
                        items: responseData.items || [],
                        total: responseData.total || 0,
                        hasMore: !!responseData.next,
                    }
                };
            }
            return { ...state };
        }

        case types.LOAD_MORE_SPOTIFY_PLAYLISTS: {
            const responseData = action.payload && action.payload.data 
                ? action.payload.data
                : null;
            if (responseData) {
                const existingItems = state.spotifyPlaylistObject ? state.spotifyPlaylistObject.items : [];
                return {
                    ...state,
                    spotifyPlaylistObject: {
                        items: existingItems.concat(responseData.items || []),
                        total: responseData.total || 0,
                        hasMore: !!responseData.next,
                    }
                };
            }
            return { ...state };
        }

        default: {
            return { ...state };
        }
    }
}
